var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9568_7970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7908 63.75C20.3718 63.75 16.1338 62.0709 13.0091 59.082C9.88435 56.0932 8.12891 52.0394 8.12891 47.8125C8.12891 43.5856 9.88435 39.5318 13.0091 36.543C16.1338 33.5541 20.3718 31.875 24.7908 31.875C25.8345 27.2254 28.8877 23.1394 33.2788 20.5159C35.453 19.2168 37.8902 18.3159 40.4513 17.8646C43.0124 17.4132 45.6472 17.4203 48.2052 17.8854C50.7632 18.3505 53.1944 19.2645 55.36 20.5752C57.5256 21.886 59.3831 23.5677 60.8265 25.5245C62.2698 27.4813 63.2709 29.6748 63.7723 31.9798C64.2738 34.2848 64.266 36.6561 63.7492 38.9583H67.2908C70.5784 38.9583 73.7314 40.2643 76.056 42.589C78.3807 44.9137 79.6867 48.0666 79.6867 51.3542C79.6867 54.6417 78.3807 57.7947 76.056 60.1193C73.7314 62.444 70.5784 63.75 67.2908 63.75H63.7492",
    stroke: "#676767",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.875 53.125L42.5 42.5L53.125 53.125",
    stroke: "#676767",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 42.5V74.375",
    stroke: "#676767",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9568_7970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.f91c905f665ac0a5a0b2faa5abac51fc.svg";
export { ForwardRef as ReactComponent };